import React from 'react';
import { Descriptions, Button, Space } from 'antd';
import dayjs from 'dayjs';

const modeLabel = (m) => {
  if (m === 'full') return '全量新增';
  if (m === 'incremental') return '增量仅新增';
  if (m === 'incremental_full_update') return '增量全更新';
  return String(m || '');
};

const UploadWorkspace = ({ workspace, onPrecheck, onImport, onReupload }) => {
  if (!workspace) {
    return (
      <Space>
        <Button type="primary" onClick={onReupload}>上传数据文件</Button>
      </Space>
    );
  }
  return (
    <>
      <Descriptions bordered size="small" column={2}>
        <Descriptions.Item label="文件名称">{workspace.fileName}</Descriptions.Item>
        <Descriptions.Item label="总行数">{workspace.totalRows}</Descriptions.Item>
        <Descriptions.Item label="工作表">{Array.isArray(workspace.worksheets) ? workspace.worksheets.join(' / ') : ''}</Descriptions.Item>
        <Descriptions.Item label="批量发布模式">{modeLabel(workspace.mode)}</Descriptions.Item>
        <Descriptions.Item label="上传时间">{dayjs(workspace.uploadedAt).format('YYYY-MM-DD HH:mm:ss')}</Descriptions.Item>
      </Descriptions>
      <Space style={{ marginTop: 12 }}>
        <Button onClick={onPrecheck}>预检</Button>
        <Button type="primary" onClick={onImport}>导入</Button>
        <Button danger onClick={onReupload}>重新上传</Button>
      </Space>
    </>
  );
};

export default UploadWorkspace;
